<template>
	<div>
		<el-table :data="tableData" border class="table el-table" ref="multipleTable" max-height="600"
			header-cell-class-name="table-header" :header-cell-style="{ 'text-align': 'center' }" v-loading="loading"
			:row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }" stripe>
			<el-table-column prop="agentName" label="代理商" align="center"></el-table-column>
			<el-table-column prop="title" label="标题" align="center"></el-table-column>
			<el-table-column prop="url" label="图片" align="center">
				<template #default="scope">
					<el-image v-if="scope.row.url" @click="bigImg(scope.row.url)"
						style="width: 50px; height: 50px; margin-bottom:-4px" :src="scope.row.url"
						:preview-src-list="srcList"></el-image>
					<span v-else></span>
				</template>
			</el-table-column>
			<el-table-column prop="createdAt" width="200" label="发布时间" align="center"></el-table-column>
			<el-table-column label="操作" width="190" align="center">
				<template #default="scope">
					<el-button size="small" type="text" icon="el-icon-delete" class="red"
						@click="handleDelete(scope.$index, scope.row.id)">删除</el-button>
					<el-button size="small" type="text" @click="handleEdit(scope.row)">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination">
			<el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="query.pageIndex"
				:page-sizes="[10, 20, 50, 100, 200, 500]" :page-size="query.pageSize" :total="pageTotal"
				@size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
		</div>
	</div>
</template>

<script>
	import {
		add,
		notice,
		delNotice
	} from '../../api/notice';
	export default {
		name: 'notice',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				tableData: [],
				limitCount: 1,
				query: {
					pageIndex: 1,
					pageSize: 10,
					userId: localStorage.getItem('user')
				},
				pageTotal: 0,
				form: {
					title: '',
					content: '',
					url: ''
				},
				domain: '',
				srcList: []
			};
		},

		created() {
			this.getNoticeList();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			getNoticeList() {
				if (!this.query.pageIndex) {
					return;
				}
				let data = {
					userId: this.query.userId,
					pageIndex: this.query.pageIndex,
					pageSize: this.query.pageSize,
				}
				notice(data).then(res => {
					if (res.code == 200) {
						this.tableData = res.data.list;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			// 删除操作
			handleDelete(index, id) {
				// 二次确认删除
				this.$confirm('确定要删除吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						delNotice(id).then(res => {
							if (res?.code === 200) {
								this.$message.success('删除成功');
								this.pageTotal = this.pageTotal - 1;
								this.tableData.splice(index, 1);
							} else {
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			},
			bigImg(url) {
				this.srcList.push(url);
			},
			handleEdit(row) {
				this.$router.push('addNotice');
				localStorage.setItem('rowNotice', JSON.stringify(row));
			},
			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getNoticeList();
			},
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.getNoticeList();
			},
		}
	};
</script>
<style>
	.red {
		color: #f56c6c;
	}

	.myRight {
		position: absolute;
		right: 10px;
		bottom: 10px;
	}
</style>